export const STALE_SHORT = 30_000

export const STALE_MEDIUM = 60_000

export const STALE_LONG = 5 * 60_000

export const GC_TIME_SHORT = 5 * 60_000

export const GC_TIME_DEFAULT = 10 * 60_000
